// GeneralLoadingComponent

import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../../services/commonServices/loading.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-general-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './general-loading.component.html',
  styleUrls: ['./general-loading.component.scss']
})
export class GeneralLoadingComponent implements OnInit {
  loading$!: Observable<boolean>;  // Declare loading$ here

  constructor(private readonly loadingService: LoadingService) {}

  ngOnInit() {
    // Initialize loading$ observable after the service is injected
    this.loading$ = this.loadingService.loading$;
  }
}
